<ng-container>
  <div class="container-fluid px-0">
    <div class="card border-0 futuristic-card">
      <div class="card-header futuristic-header form-section">
        <div class="row align-items-center">
          <div class="col-lg-6 col-sm-12 col-md-12 mt-mobile-tile" style="">
            <div class="d-flex flex-column align-items-center">
              <div class="text-center">
                <h4 class="bold text-center mt-1">{{ this.nomeEntidade }}</h4>
                <h4 class="bold text-center mt-1">{{ this.razaoSocialEntidade }}</h4>
                <div class="product-container mt-2">
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="product-icon me-2">
                      <i class="bi bi-file-earmark-text"></i>
                    </div>
                    <h6 class="product-name mb-0">
                      {{ _listaDocumentosTitular.product || nomeProduto }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="mobile-title">
              <div class="title-section mb-4">
                <div class="d-flex align-items-center mb-3">
                  <h4 class="main-title m-0">
                    DOCUMENTOS PARA COMPROVAÇÃO
                    <br />
                    <span class="highlight-text">DE ELEGIBILIDADE</span>
                  </h4>
                </div>

                <div class="status-bar">
                  <div class="status-progress"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Abas -->
  <hr />
  <!-- <pre>_listaDocumentosTitular? - {{ listaRetornoEnvio | json }}</pre> -->

  <!-- Conteúdo dos Acordeões -->
  <mat-horizontal-stepper [linear]="isLinear" #stepper>
    <mat-step label="TITULAR e DEPENDENTE">
      <div class="container-fluid px-0">
        <div class="border-0 futuristic-card">
          <div class="accordion" id="accordionExample">
            <ng-container *ngIf="!inclusaoDependente">
              <!-- Acordeão do Titular -->

              <div
                class="card-header collapse-format border-info info"
                [ngClass]="{
                  'border-warning':
                    !dadosCarregados || verificarPendenciaPorPerfil(_listaDocumentosTitular?.name, 'Titular'),
                  'border-success':
                    dadosCarregados && !verificarPendenciaPorPerfil(_listaDocumentosTitular?.name, 'Titular')
                }"
                id="headingOne">
                <h2 class="mb-0 card-title lead info">
                  <button
                    (click)="alternarAcordeao(_listaDocumentosTitular.holderId)"
                    class="btn btn-link btn-block text-left text-white bold"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTitular"
                    aria-expanded="true"
                    aria-controls="collapseTitular">
                    <i class="fa fa-user" aria-hidden="true"></i>
                    TITULAR - {{ _listaDocumentosTitular.name | uppercase }}
                    <br />

                    <span
                      *ngIf="verificarPendenciaPorPerfil(_listaDocumentosTitular?.name, 'Titular')"
                      class="mt-1 bold text-center animate-info text-white ms-2">
                      <i class="fa fa-exclamation-triangle"></i>
                      Atenção! Identifiquei pendência(s) no titular, favor verificar.
                    </span>
                  </button>
                </h2>
              </div>

              <div id="collapseTitular" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                  <!-- Conteúdo do titular header -->

                  <div class="row mb-3 col-md-12 col-sm-12">
                    <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                      <h4 class="bold">
                        <strong>
                          <i class="fa fa-user"></i>
                          Nome:
                        </strong>
                        {{ _listaDocumentosTitular.name }}
                      </h4>
                    </div>
                    <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                      <h4 class="bold">
                        <strong>
                          <i class="fa fa-briefcase"></i>
                          Profissão:
                        </strong>
                        {{ _listaDocumentosTitular.profession }}
                      </h4>
                    </div>
                    <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                      <h4 class="bold">
                        <strong>
                          <i class="fa fa-circle"></i>
                          Tipo Proposta:
                        </strong>
                        {{ tipoPropostaTitular || '' }}
                      </h4>
                    </div>

                    <div class="title-section mt-3 col-md-12 col-sm-12">
                      <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                        <h4 class="info main-title m-0 mb-2 mb-md-0">
                          <strong>Anexo os documentos necessários para aprovação do Titular</strong>
                          :
                        </h4>
                        <div *ngIf="podeABrirModalFormularioInscricao" class="w-100 w-md-auto">
                          <button
                            class="btn btn-simule btn btn-success btn-min-width"
                            (click)="buscarDadosPropostaEntidadeFormulario()">
                            <i class="fa fa-id-card"></i>
                            Formulário de Inscrição
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Documentos do Titular -->
                  <div
                    *ngIf="
                      _listaDocumentosTitular.documents && _listaDocumentosTitular.documents.length > 0;
                      else semDocumentosTitular
                    ">
                    <!-- <pre>{{ _listaDocumentosTitular.documents | json }}</pre> -->
                    <div *ngFor="let categoria of _listaDocumentosTitular.documents" class="col-md-12 col-sm-12 mt-2">
                      <div class="row">
                        <div class="col-xl-12 col-md-12 col-sm-12">
                          <div
                            class="card"
                            style="
                              height: auto;
                              box-shadow:
                                rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
                                rgba(0, 0, 0, 0.3) 0px 30px 60px -30px !important;
                            ">
                            <div class="card-header bg-info text-white">
                              <h3 style="font-size: 1.2em !important" class="card-title mb-0 text-white bold">
                                {{ categoria.groupTitle }}
                              </h3>
                            </div>
                            <div class="card-content position-relative">
                              <div
                                class="scroll-indicator-left d-flex d-md-none"
                                *ngIf="categoria.documents.length > 1"
                                (click)="scrollLeft(scrollContainer)">
                                <i class="fa fa-chevron-left blinking-arrow"></i>
                              </div>

                              <div
                                class="scroll-indicator d-flex d-md-none"
                                *ngIf="categoria.documents.length > 1"
                                (click)="scrollRight(scrollContainer)">
                                <i class="fa fa-chevron-right blinking-arrow"></i>
                              </div>

                              <div class="scroll-hint-mobile d-flex d-md-none" *ngIf="categoria.documents.length > 1">
                                <div class="scroll-hint-content">
                                  <i class="fa fa-hand-point-right"></i>
                                  <span>Deslize para ver mais</span>
                                </div>
                              </div>
                              <div
                                [class]="
                                  categoria.documents.length === 2 || categoria.documents.length === 1
                                    ? 'd-flex align-left'
                                    : 'd-flex justify-content-around'
                                "
                                style="background-color: #6c757d33"
                                class="card-body gap-3 subcard-scroll-wrapper card-document-mobile">
                                <app-documento-card-list
                                  *ngFor="let documento of categoria?.documents || []"
                                  [titulo]="documento.title"
                                  [imagemSrc]="documento.iconPath"
                                  [status]="documento.status"
                                  [tipoDocumento]="documento.documentType"
                                  [heColaborador]="heColaborador"
                                  (onClick)="
                                    enviarOuAprovarDocumento(
                                      modalContentVisualizar,
                                      templateModalUpload,
                                      documento.filePath,
                                      documento.documentProposalId,
                                      'titular',
                                      _listaDocumentosTitular.holderId,
                                      documento.documentStatusEnum,
                                      documento,
                                      documento.documentType,
                                      documento.description,
                                      documento.documentProposalId,
                                      categoria.groupDocument,
                                      documento.dataUrl,
                                      documento.observation
                                    )
                                  "
                                  (abrirModal)="
                                    abrirModal(
                                      templateModalUpload,
                                      documento.documentType,
                                      'titular',
                                      documento.description,
                                      documento.documentProposalId,
                                      documento.filePath,
                                      categoria.groupDocument,
                                      _listaDocumentosTitular.holderId,
                                      documento.dataUrl,
                                      documento.observation,
                                      documento.status
                                    )
                                  "></app-documento-card-list>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #semDocumentosTitular>
                    <h4 class="text-bold-500">
                      <h1>Não foi localizado nenhum documento para este titular.</h1>
                    </h4>
                  </ng-template>

                  <!-- Formulário do Titular -->

                  <ng-container *ngIf="heColaborador">
                    <div class="card-content">
                      <div class="card-body">
                        <form [formGroup]="formGroupTitular">
                          <div class="col-12">
                            <div class="form-group row">
                              <div class="form-group mb-1 col-sm-12 col-md-12">
                                <label for="defaultWithAdmServ">
                                  Inadimplência com a Admserv de contratos anteriores cancelados.
                                </label>
                                <br />
                                <label style="margin-right: 50px">
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        formGroupTitular.controls['defaultWithAdmServ'].errors && isFormSubmitedTitular
                                    }"
                                    (input)="onFieldChange()"
                                    (ngModelChange)="onFieldChange()"
                                    (change)="atualizaFormularioTitular()"
                                    formControlName="defaultWithAdmServ"
                                    [value]="false"
                                    id="active"
                                    type="radio"
                                    class="input-radio off"
                                    name="defaultWithAdmServ"
                                    checked />
                                  Não
                                </label>
                                <label>
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        formGroupTitular.controls['defaultWithAdmServ'].errors && isFormSubmitedTitular
                                    }"
                                    (input)="onFieldChange()"
                                    (ngModelChange)="onFieldChange()"
                                    (change)="atualizaFormularioTitular()"
                                    formControlName="defaultWithAdmServ"
                                    [value]="true"
                                    id="Inactive"
                                    type="radio"
                                    class="input-radio on"
                                    name="defaultWithAdmServ"
                                    checked />
                                  Sim
                                </label>
                                <app-validacao-form-input
                                  [nomeFormulario]="formGroupTitular"
                                  nomeCampo="defaultWithAdmServ"
                                  [isFormSubmited]="isFormSubmitedTitular"></app-validacao-form-input>
                              </div>
                              <!-- Carência -->
                              <div class="form-group col-md-6 col-sm-12">
                                <label for="neediness">Carência</label>
                                <ng-select
                                  (input)="onFieldChange()"
                                  (ngModelChange)="onFieldChange()"
                                  (change)="atualizaFormularioTitular()"
                                  [multiple]="false"
                                  [loading]="false"
                                  [closeOnSelect]="true"
                                  [searchable]="true"
                                  class="round shadow"
                                  formControlName="neediness"
                                  [ngClass]="{
                                    'is-invalid': formGroupTitular.controls['neediness'].errors && isFormSubmitedTitular
                                  }"
                                  notFoundText="Nenhum registro localizado">
                                  <ng-option *ngFor="let itemCarencia of lisaDeCarencias" [value]="itemCarencia.value">
                                    {{ itemCarencia.description }}
                                  </ng-option>
                                </ng-select>
                                <app-validacao-form-input
                                  [nomeFormulario]="formGroupTitular"
                                  nomeCampo="neediness"
                                  [isFormSubmited]="isFormSubmitedTitular"></app-validacao-form-input>
                              </div>
                              <!-- Demais pendência na proposta-->
                              <div class="form-group mb-1 col-sm-12 col-md-6">
                                <label for="otherPendingIssues">Demais pendência na proposta</label>
                                <br />
                                <label style="margin-right: 50px">
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        formGroupTitular.controls['otherPendingIssues'].errors && isFormSubmitedTitular
                                    }"
                                    (input)="onFieldChange()"
                                    (ngModelChange)="validarCampoObservacao($event)"
                                    (change)="atualizaFormularioTitular()"
                                    formControlName="otherPendingIssues"
                                    [value]="true"
                                    id="active"
                                    type="radio"
                                    class="input-radio off"
                                    name="otherPendingIssues"
                                    checked />
                                  Possui
                                </label>
                                <label>
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        formGroupTitular.controls['otherPendingIssues'].errors && isFormSubmitedTitular
                                    }"
                                    (input)="onFieldChange()"
                                    (ngModelChange)="validarCampoObservacao($event)"
                                    (change)="atualizaFormularioTitular()"
                                    formControlName="otherPendingIssues"
                                    [value]="false"
                                    id="Inactive"
                                    type="radio"
                                    class="input-radio on"
                                    name="otherPendingIssues" />
                                  Não Possui
                                </label>
                                <app-validacao-form-input
                                  [nomeFormulario]="formGroupTitular"
                                  nomeCampo="otherPendingIssues"
                                  [isFormSubmited]="isFormSubmitedTitular"></app-validacao-form-input>
                              </div>
                              <!-- Observação Apoio -->
                              <div class="form-group mb-1 col-sm-12 col-md-5 text-area-mobile">
                                <label for="noteSupport">Observação Apoio</label>
                                <textarea
                                  type="text"
                                  id="noteSupport"
                                  class="form-control round bg-white shadow"
                                  (input)="onFieldChange()"
                                  (ngModelChange)="onFieldChange()"
                                  (change)="atualizaFormularioTitular()"
                                  formControlName="noteSupport"
                                  [ngClass]="{
                                    'is-invalid':
                                      formGroupTitular.controls['noteSupport'].errors && isFormSubmitedTitular
                                  }"></textarea>
                                <app-validacao-form-input
                                  [nomeFormulario]="formGroupTitular"
                                  nomeCampo="noteSupport"
                                  [maxLength]="250"
                                  [isFormSubmited]="isFormSubmitedTitular"></app-validacao-form-input>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <!-- DEPENDENTE -->
            <div class="card mt-2 mb-2">
              <ng-container *ngFor="let dependente of propostaCompleta; let i = index">
                <div
                  class="card-header collapse-format border-warning mb-2"
                  id="headingTwo"
                  [ngClass]="{
                    'border-warning': !dadosCarregados || verificarPendenciaPorPerfil(dependente?.name, 'Dependente'),
                    'border-success': dadosCarregados && !verificarPendenciaPorPerfil(dependente?.name, 'Dependente')
                  }">
                  <h2 class="mb-0 card-title lead info">
                    <button
                      (click)="abrirDetalhesDependente(dependente); preencherDados(false, i)"
                      class="btn text-white bold btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      [attr.href]="'#colapseDependente' + i"
                      [attr.data-target]="'#colapseDependente' + i"
                      [attr.aria-expanded]="false"
                      [attr.aria-controls]="'colapseDependente' + i">
                      <i class="fa fa-child" aria-hidden="true"></i>
                      DEPENDENTE - {{ dependente.name | uppercase }}
                      <br />
                      <span
                        *ngIf="verificarPendenciaPorPerfil(dependente?.name, 'Dependente')"
                        class="mt-1 bold text-center animate-info text-white ms-2">
                        <i class="fa fa-exclamation-triangle"></i>
                        Atenção! Identifiquei pendência(s) neste dependente, favor verificar.
                      </span>
                    </button>
                  </h2>
                </div>

                <div
                  [id]="'colapseDependente' + i"
                  class="collapse"
                  [attr.aria-labelledby]="'headingcolapseDependente' + i"
                  data-parent="#accordionExample">
                  <div class="card-body">
                    <ng-container *ngIf="dependente.documentos.length == 0 && exibirMensagemAvisoDependente">
                      <div
                        class="mt-5 alert row justify-content-center align-items-center col-md-12 round alert-icon-left alert-arrow-left alert-danger alert-dismissible mb-2"
                        role="alert">
                        <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>
                        <ng-container>
                          <h4 class="text-bold-500">
                            <h1>Não foi localizado nenhum documento para este dependente.</h1>
                          </h4>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container>
                      <div class="card-content">
                        <div class="card-body">
                          <div class="col-12">
                            <div class="form-group row">
                              <div class="row mb-3 col-md-12 col-sm-12">
                                <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                                  <h4 class="bold">
                                    <strong>
                                      <i class="fa fa-user"></i>
                                      Nome:
                                    </strong>
                                    {{ dependente.name }}
                                  </h4>
                                </div>
                                <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                                  <h4 class="bold">
                                    <strong>
                                      <i class="fa fa-child"></i>
                                      Parentesco:
                                    </strong>
                                    {{ dependente.branchCompanyContractKinshipDescription }}
                                  </h4>
                                </div>
                                <div class="col-md-4 col-sm-12 dados-informativo-pessoa-mobile">
                                  <h4 class="bold">
                                    <strong>
                                      <i class="fa fa-circle"></i>
                                      Tipo Proposta:
                                    </strong>
                                    {{ dependente.proposalTypeName }}
                                  </h4>
                                </div>

                                <div class="title-section mt-3 col-md-12 col-sm-12">
                                  <div
                                    class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                    <h4 class="info main-title m-0 mb-2 mb-md-0">
                                      <strong>Anexo os documentos necessários para aprovação do dependente</strong>
                                      :
                                    </h4>
                                  </div>
                                </div>
                              </div>
                              <!-- DADOS DEPENDENTE -->
                              <div
                                *ngFor="let documentsDependente of dependente.documentos?.documents || []"
                                class="col-md-12 col-sm-12 mt-2">
                                <div class="row">
                                  <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div
                                      class="card"
                                      style="
                                        height: auto;
                                        box-shadow:
                                          rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
                                          rgba(0, 0, 0, 0.3) 0px 30px 60px -30px !important;
                                      ">
                                      <div class="card-header bg-info text-white">
                                        <h3 style="font-size: 1.2em !important" class="card-title mb-0 text-white bold">
                                          {{ documentsDependente.groupTitle }}
                                        </h3>
                                      </div>

                                      <div class="card-content position-relative">
                                        <div
                                          class="scroll-indicator-left d-flex d-md-none"
                                          *ngIf="documentsDependente.documents.length > 1"
                                          (click)="scrollLeft(scrollContainer)">
                                          <i class="fa fa-chevron-left blinking-arrow"></i>
                                        </div>

                                        <div
                                          class="scroll-indicator d-flex d-md-none"
                                          *ngIf="documentsDependente.documents.length > 1"
                                          (click)="scrollRight(scrollContainer)">
                                          <i class="fa fa-chevron-right blinking-arrow"></i>
                                        </div>

                                        <div
                                          class="scroll-hint-mobile d-flex d-md-none"
                                          *ngIf="documentsDependente.documents.length > 1">
                                          <div class="scroll-hint-content">
                                            <i class="fa fa-hand-point-right"></i>
                                            <span>Deslize para ver mais</span>
                                          </div>
                                        </div>
                                        <div
                                          [class]="
                                            documentsDependente.documents.length === 2 ||
                                            documentsDependente.documents.length === 1
                                              ? 'd-flex align-left'
                                              : 'd-flex justify-content-around'
                                          "
                                          style="background-color: #6c757d33"
                                          class="card-body gap-3 subcard-scroll-wrapper card-document-mobile">
                                          <app-documento-card-list
                                            *ngFor="let documentoDependente of documentsDependente?.documents || []"
                                            [titulo]="documentoDependente.title"
                                            [imagemSrc]="documentoDependente.iconPath"
                                            [status]="documentoDependente.status"
                                            [tipoDocumento]="documentoDependente.documentType"
                                            [heColaborador]="heColaborador"
                                            (onClick)="
                                              enviarOuAprovarDocumento(
                                                modalContentVisualizar,
                                                templateModalUpload,
                                                documentoDependente.filePath,
                                                documentoDependente.documentProposalId,
                                                'dependente',
                                                dependente.documentos.dependentId,
                                                documentoDependente.documentStatusEnum,
                                                documentoDependente,
                                                documentoDependente.documentType,
                                                documentoDependente.description,
                                                documentoDependente.documentProposalId,
                                                documentsDependente.groupDocument,
                                                documentoDependente.dataUrl,
                                                documentoDependente.observation
                                              )
                                            "
                                            (abrirModal)="
                                              abrirModal(
                                                templateModalUpload,
                                                documentoDependente.documentType,
                                                'dependente',
                                                documentoDependente.description,
                                                documentoDependente.documentProposalId,
                                                documentoDependente.filePath,
                                                documentsDependente.groupDocument,
                                                dependente.documentos.dependentId,
                                                documentoDependente.dataUrl,
                                                documentoDependente.observation,
                                                documentsDependente.status
                                              )
                                            "></app-documento-card-list>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Form dependentes -->
                              <ng-container *ngIf="heColaborador">
                                <div class="card-content">
                                  <div class="card-body">
                                    <form [formGroup]="formGroupDependentes[i]">
                                      <div class="col-12">
                                        <div class="form-group row">
                                          <!-- Carência -->

                                          <div class="form-group col-md-6 col-sm-12">
                                            <label for="neediness">Carência</label>
                                            <ng-select
                                              (input)="onFieldChange(dependente.id)"
                                              (ngModelChange)="onFieldChange(dependente.id, dependente.name)"
                                              (change)="atualizaFormularioDependente(i)"
                                              [multiple]="false"
                                              [loading]="false"
                                              [closeOnSelect]="true"
                                              [searchable]="true"
                                              class="round shadow"
                                              formControlName="neediness"
                                              [ngClass]="{
                                                'is-invalid':
                                                  formGroupDependentes[i].controls['neediness'].errors &&
                                                  isFormSubmitedDependente
                                              }"
                                              notFoundText="Nenhum registro localizado">
                                              <ng-option
                                                *ngFor="let itemCarencia of lisaDeCarencias"
                                                [value]="itemCarencia.value">
                                                {{ itemCarencia.description }}
                                              </ng-option>
                                            </ng-select>
                                            <app-validacao-form-input
                                              [nomeFormulario]="formGroupDependentes[i]"
                                              nomeCampo="neediness"
                                              [isFormSubmited]="isFormSubmitedDependente"
                                              [maxLength]="250"></app-validacao-form-input>
                                          </div>
                                          <!-- Demais pendência na proposta-->
                                          <div class="form-group mb-1 col-sm-12 col-md-12">
                                            <label for="otherPendingIssues">Demais pendência na proposta</label>
                                            <br />
                                            <label style="margin-right: 50px">
                                              <input
                                                [ngClass]="{
                                                  'is-invalid':
                                                    formGroupDependentes[i].controls['otherPendingIssues'].errors &&
                                                    isFormSubmitedDependente
                                                }"
                                                (input)="onFieldChange(dependente.id, dependente.name)"
                                                (ngModelChange)="
                                                  validarCampoObservacaoDependente($event, i, dependente.name)
                                                "
                                                (change)="atualizaFormularioDependente(i)"
                                                formControlName="otherPendingIssues"
                                                [value]="true"
                                                id="active"
                                                type="radio"
                                                class="input-radio off"
                                                name="otherPendingIssues"
                                                checked />
                                              Possui
                                            </label>
                                            <label>
                                              <input
                                                (input)="onFieldChange(dependente.id, dependente.name)"
                                                (ngModelChange)="
                                                  validarCampoObservacaoDependente($event, i, dependente.name)
                                                "
                                                (change)="atualizaFormularioDependente(i)"
                                                formControlName="otherPendingIssues"
                                                [value]="false"
                                                id="Inactive"
                                                type="radio"
                                                class="input-radio on"
                                                name="otherPendingIssues" />
                                              Não Possui
                                            </label>
                                          </div>
                                          <!-- Observação Apoio -->
                                          <div class="form-group mb-1 col-sm-12 col-md-5 text-area-mobile">
                                            <label for="noteSupport">Observação Apoio</label>
                                            <textarea
                                              type="text"
                                              id="noteSupport"
                                              class="form-control round bg-white shadow"
                                              (input)="onFieldChange(dependente.id)"
                                              (ngModelChange)="onFieldChange(dependente.id)"
                                              (change)="atualizaFormularioDependente(i)"
                                              [ngClass]="{
                                                'is-invalid':
                                                  formGroupDependentes[i].controls['noteSupport'].errors &&
                                                  isFormSubmitedDependente
                                              }"
                                              formControlName="noteSupport"></textarea>
                                            <app-validacao-form-input
                                              [nomeFormulario]="formGroupDependentes[i]"
                                              nomeCampo="noteSupport"
                                              [isFormSubmited]="isFormSubmitedDependente"
                                              [maxLength]="250"></app-validacao-form-input>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- Step para Dependentes -->
    <!-- <mat-step label="DEPENDENTES"></mat-step> -->
  </mat-horizontal-stepper>
  <ng-container *ngIf="!ehCorretor">
    <div class="button-mobile d-flex justify-content-end w-100 mt-2">
      <button
        *ngIf="this.stepAtual == propostaEnum.DOCUMENTO && podeCadastrarEditar && heColaborador"
        class="btn round btn-outline-info btn-min-width"
        (click)="avancarProximoStep()">
        Avançar
        <i class="fa fa-arrow-right"></i>
      </button>
      <!-- Só deve mostrar quando estiver na etapa 10 -->
      <ng-container *ngIf="this.stepAtual == propostaEnum.ANALISE && podeCadastrarEditar">
        <app-declinio-proposta
          [stepAtual]="stepAtual"
          *ngIf="heColaborador"
          (propostaDeclinada)="receberDeclinio($event)"></app-declinio-proposta>
        <button
          *ngIf="heColaborador"
          (click)="visualizarArquivoDevolvidos(modalContentVisualizarArquivosDevolvido)"
          class="btn btn-outline-info bold round mr-1 btn-min-width box-shadow-4"
          style="max-height: 3rem">
          <i class="fa fa-search"></i>
          Documento(s) Devolvido(s)
        </button>
        <button
          *ngIf="heColaborador"
          (click)="colaboradorAvancar(templateModalAlerta)"
          class="btn btn-outline-success bold round btn-min-width box-shadow-4"
          style="max-height: 3rem">
          <i class="fa fa-send"></i>
          Enviar
        </button>
      </ng-container>

      <!-- SOMENTE PARA BENEFICIARIO-->
      <button
        *ngIf="!heColaborador"
        class="btn round btn-outline-info btn-min-width"
        (click)="beneficiarioAvancar(templateModalAlerta, templateModalExistente)">
        Próximo
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </ng-container>
</ng-container>

<!-- MODAL UPLOAD START -->
<ng-template #templateModalUpload>
  <div *ngIf="!heColaborador" class="modal-header bg bg-info">
    <h5 class="modal-title white title-modal">Documentos</h5>
    <button (click)="fecharModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center container"></div>
  <div class="container-fluid text-justify">
    <div class="modal-body body-modal-mobile">
      <div class="row">
        <div class="col-md-6">
          <ng-container>
            <span [innerHTML]="this.descricaoDocumento" class="descricao-documento"></span>
          </ng-container>

          <hr />
          <p>
            Lembre-se de que, ao enviar documentos pessoais, todos os dados devem ser verídicos e atualizados. Esses
            dados estarão protegidos em conformidade com a
            <strong>Lei Geral de Proteção de Dados Pessoais (LGPD)</strong>
            , que assegura a privacidade e a segurança das informações fornecidas. A falsificação ou adulteração de
            informações está sujeita a penalidades conforme o Código Penal brasileiro.
          </p>

          <p class="mt-2 text-justify"><strong>Instruções de Envio:</strong></p>
          <ul>
            <li>Formatos permitidos: JPG, PNG, PDF</li>
            <li>Tamanho máximo: 5 MB</li>
            <li>Certifique-se de que o arquivo esteja claro e legível</li>
          </ul>
        </div>

        <div class="col-md-6">
          <div class="upload text-justify">
            <div class="custom-file-upload input-group">
              <input
                style="height: 41px !important"
                id="inputDocumentoUpload"
                placeholder="Selecione um documento."
                class="form-control inputDocumentoUpload"
                readonly
                type="file"
                (change)="uploadDocumento($event)"
                [attr.disabled]="somenteLeituraStep ? true : null"
                (change)="!somenteLeituraStep && uploadDocumento($event)" />
              <div class="buttons-mobile">
                <app-geia-button
                  *ngIf="!somenteLeituraStep"
                  type="info"
                  label=""
                  icon="fa fa-upload"
                  (onClick)="abrirInputDocumento()"
                  extraClass="btn-border"></app-geia-button>
              </div>

              <div class="buttons-mobile">
                <app-geia-button
                  *ngIf="visualizarArquivoUrl"
                  type="primary"
                  label=""
                  icon="fa fa-eye"
                  (onClick)="
                    abrirModalVisualizarDocumento(modalContentVisualizar, '', codigoDocumento, '', '', '', '', true)
                  "
                  extraClass="btn-border buttons-mobile"></app-geia-button>
              </div>
              <div class="buttons-mobile">
                <app-geia-button
                  *ngIf="baixarArquivo"
                  type="warning"
                  label=""
                  icon="fa fa-download"
                  (onClick)="arquivoBlobDownload()"
                  extraClass="btn-border buttons-mobile"></app-geia-button>
              </div>

              <hr />
            </div>
          </div>
          <div
            *ngIf="motivoDevolucaoDocumento"
            class="alert round alert-icon-left alert-arrow-left alert-danger alert-dismissible mb-2"
            role="alert">
            <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>
            <ng-container *ngIf="motivoDevolucaoDocumento">
              <h3>
                <strong class="text-white">Motivo Reprovação:</strong>
                <br />
              </h3>
              <h4 class="text-white">{{ motivoDevolucaoDocumento }}</h4>
            </ng-container>
          </div>
          <div
            *ngIf="mensagemTemporaria"
            class="alert round alert-icon-left alert-arrow-left alert-warning alert-dismissible mb-2"
            role="alert">
            <span class="alert-icon"><i class="fa fa-1x fa-exclamation-triangle"></i></span>

            <strong>{{ mensagemTemporaria }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- soment para. a. proposta interna colaborador -->
  <div *ngIf="!somenteLeituraStep && podeMostrarBotaoAcaoPorPerfil()" class="modal-footer">
    <app-geia-button
      type="info"
      label="Fechar"
      icon="fa fa-times"
      (onClick)="fecharModal()"
      extraClass="round"></app-geia-button>

    <app-geia-button
      *ngIf="!somenteLeituraStep"
      [disabled]="!documentoValido"
      type="success"
      label="{{ nomeBotaoAcao }}"
      icon="fa fa-send "
      extraClass="round"
      (onClick)="enviarArquivoUploaded()"></app-geia-button>
  </div>
</ng-template>
<!-- MODAL UPLOAD END -->

<!-- MODAL VIEW DOCUMENT start -->
<!-- Modal de documentos devolvidos -->
<ng-template #modalContentVisualizarArquivosDevolvido let-modal="modal">
  <div class="modal-header">
    <h4 class="modal-title">Documentos Devolvidos</h4>
    <button type="button" class="close" (click)="fecharModal()"><i class="fa fa-times"></i></button>
  </div>

  <div class="modal-body">
    <div class="table-responsive" *ngIf="listaDocuemntosProcessadosReprovados.length >= 1; else nenhumDoc">
      <table class="table table-striped">
        <thead class="bg-table-geia text-white">
          <tr>
            <th>Nome</th>
            <th>Tipo</th>
            <th>Grupo Documento</th>
            <th>Título</th>
            <th>Observação</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of listaDocuemntosProcessadosReprovados">
            <td>{{ doc.nome }}</td>
            <td>
              <span
                ngbTooltip="{{ doc.tipo }}"
                tooltipClass="tooltip cursor"
                class="badge round"
                [class]="doc.tipo === 'Titular' ? 'badge-success' : 'badge-warning'">
                {{ doc.tipo | SliceStringNamePipe }}
              </span>
            </td>
            <td>
              <span ngbTooltip="{{ doc.grupoDocumento }}" tooltipClass="tooltip cursor">
                {{ doc.grupoDocumento | SliceStringNamePipe }}
              </span>
            </td>
            <td>{{ doc.tituloDocumento }}</td>
            <td>
              <span ngbTooltip="{{ doc.observacao }}" tooltipClass="tooltip cursor">
                {{ doc.observacao || 'Sem observação' | SliceStringNamePipe }}
              </span>
            </td>
            <td>
              <div role="group" class="btn-group d-flex justify-content-center align-items-center">
                <button
                  ngbTooltip="Baixar Documento"
                  class="btn btn-round cursor-pointer box-shadow-4 btn-primary"
                  *ngIf="doc.dataUrl"
                  (click)="baixarDocumento(doc)">
                  <i class="fa fa-download"></i>
                </button>
                <button
                  ngbTooltip="Visualizar Documento"
                  class="btn btn-round cursor-pointer box-shadow-4 btn-info"
                  style="border-bottom-right-radius: 50%; border-top-right-radius: 50%"
                  (click)="
                    abrirModalVisualizarDocumento(
                      modalContentVisualizar,
                      doc.dataUrl,
                      codigoDocumento,
                      '',
                      '',
                      '',
                      '',
                      true,
                      null,
                      null,
                      true
                    )
                  ">
                  <i class="fa fa-eye fa-lg"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #nenhumDoc>
      <div class="alert round alert-icon-left alert-arrow-left alert-info alert-dismissible mb-2" role="alert">
        <span class="alert-icon"><i class="fa fa-1x fa-info"></i></span>
        <ng-container>
          <h4 class="text-bold-500">
            <h1>Não há documentos devolvidos para esta proposta.</h1>
          </h4>
        </ng-container>
      </div>
    </ng-template>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-info round" (click)="fecharModal()">
      <i class="fa fa-times"></i>
      Fechar
    </button>
  </div>
</ng-template>
<!-- MODAL VIEW DOCUMENT end -->

<ng-template #modalContentVisualizar let-modal>
  <div class="modal-header bg bg-warning">
    <h5 class="modal-title white title-modal" id="exampleModalLongTitle">Visualizar Documento</h5>
    <button (click)="fecharModalVisualizar()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="!visualizarArquivoUrl">
      <h1 class="text-center">NENHUM DUCUMENTO CARREGADO...</h1>
    </ng-container>
    <ng-container *ngIf="visualizarArquivoUrl">
      <!-- Informações e botões acima -->
      <div class="card p-1 shadow mb-1 w-100">
        <ng-container *ngIf="documentoFiltradoModal?.documentos?.length">
          <ng-container *ngIf="heColaborador || ehCorretor">
            <div *ngIf="documentoFiltradoModal.documentos[0] as doc" class="mb-1 p-1 border rounded shadow-sm">
              <h4 ngbTooltip="{{ documentoFiltradoModal.documentTitle }}" class="bold mb-1">
                Analisando:
                {{ documentoFiltradoModal.documentTitle }}
              </h4>
              <hr />
              <div *ngIf="doc.extraData">
                <div class="row">
                  <div class="col-md-4 mb-1" *ngFor="let key of objectKeys(doc.extraData)">
                    <strong>{{ key }}:</strong>
                    {{ doc.extraData[key] }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <!-- Upload Documento -->
        <div class="upload text-justify" *ngIf="mostrarUploadDocumentoColaborador">
          <div class="custom-file-upload input-group justify-content-center align-items-center">
            <input
              style="height: 41px !important"
              id="inputDocumentoUpload"
              placeholder="Selecione um documento."
              class="form-control inputDocumentoUpload"
              readonly
              type="file"
              (change)="uploadDocumento($event)"
              [attr.disabled]="somenteLeituraStep ? true : null"
              (change)="!somenteLeituraStep && uploadDocumento($event)" />
            <div class="buttons-mobile">
              <app-geia-button
                type="info"
                label=""
                icon="fa fa-upload"
                (onClick)="abrirInputDocumento()"
                extraClass="btn-border"></app-geia-button>
            </div>

            <div class="modal-footer">
              <app-geia-button
                *ngIf="!somenteLeituraStep"
                [disabled]="!documentoValido"
                type="success"
                label="{{ nomeBotaoAcao }}"
                icon="fa fa-send "
                extraClass="round"
                (onClick)="enviarArquivoUploaded()"></app-geia-button>
            </div>
            <hr />
          </div>
        </div>
        <!-- Botões -->
        <div class="zoom-controls text-end mt-2">
          <button ngbTooltip="Diminuir Zoom" class="btn btn-sm btn-warning me-2" (click)="diminuirZoom()">
            <i class="fa fa-search-minus"></i>
          </button>
          <button ngbTooltip="Aumentar Zoom" class="btn btn-sm btn-warning me-2" (click)="aumentarZoom()">
            <i class="fa fa-search-plus"></i>
          </button>
          <button ngbTooltip="Girar Esquerda" class="btn btn-sm btn-primary me-2" (click)="girarEsquerda()">
            <i class="fa fa-undo"></i>
          </button>
          <button ngbTooltip="Girar Direita" class="btn btn-sm btn-primary me-2" (click)="girarImagemDireita()">
            <i class="fa fa-repeat"></i>
          </button>
          <button ngbTooltip="Resetar Visualização" class="btn btn-sm btn-secondary" (click)="resetarVisualizacao()">
            <i class="fa fa-refresh"></i>
          </button>
        </div>
      </div>

      <!-- Área da imagem/PDF com scroll livre -->
      <div
        class="document-container"
        style="
          height: 75vh;
          overflow: auto;
          border: 1px solid #ddd;
          background: #f8f9fa;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <div *ngIf="ehImagem; else exibirPdfOuOutro" style="min-width: max-content; min-height: max-content">
          <img
            style="cursor: pointer"
            [src]="visualizarArquivoUrl"
            (load)="onImageLoad($event)"
            [style.transform]="'rotate(' + rotation + 'deg)'"
            [style.width.px]="calcImgWidth()"
            style="height: auto; transition: all 0.3s ease-in-out"
            alt="Documento imagem" />
        </div>

        <ng-template #exibirPdfOuOutro>
          <div style="cursor: pointer; width: 100%; height: 100%">
            <pdf-viewer
              [src]="visualizarArquivoUrl"
              [rotation]="rotation"
              [original-size]="false"
              [fit-to-page]="false"
              [zoom]="zoom"
              [zoom-scale]="'page-width'"
              [stick-to-page]="false"
              [render-text]="true"
              [autoresize]="true"
              [show-borders]="false"
              style="width: 100%; height: 100%"></pdf-viewer>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <app-geia-button
      type="info"
      label="Fechar"
      icon="fa fa-times"
      (onClick)="fecharModalVisualizar()"
      extraClass="round"></app-geia-button>
    <app-geia-button
      *ngIf="heColaborador && this.stepAtual >= propostaEnum.ANALISE && !ocultarBtnAcaoVisualizar"
      label="Baixar"
      icon="fa fa-download"
      (onClick)="baixarDocumento(documentoEmTela)"
      extraClass="round"></app-geia-button>
    <ng-container *ngIf="!somenteLeituraStep && !ocultarBtnAcaoVisualizar">
      <ng-container *ngIf="podeMostrarBotaoAcaoValidarDocumento()">
        <app-geia-button
          *ngIf="!mostrarBotaoAprovarDocumento"
          type="success"
          label="Aprovar"
          icon="fa fa-check"
          (onClick)="abrirModalConfirmar(templateModalConfirme, _statusDocumentoEnum.OK, false)"
          extraClass="round"></app-geia-button>
        <app-geia-button
          *ngIf="mostrarBotaoDevolver"
          type="warning"
          label="Devolver"
          icon="fa fa-arrow-left"
          (onClick)="abrirModalConfirmar(templateModalConfirme, _statusDocumentoEnum.CORRECAO, true)"
          extraClass="round"></app-geia-button>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #templateModalConfirme>
  <app-confirm-modal
    [title]="tituloAcaoModal"
    [message]="mensagemConfirmacao"
    (confirm)="confirme()"
    (cancel)="decline()"></app-confirm-modal>
  <br />
  <!-- Se for uma devolução, exibe o campo de motivo -->
  <div *ngIf="exibirMotivo" class="motivo-container">
    <label for="motivo" class="motivo-label">Motivo da devolução:</label>
    <textarea [(ngModel)]="motivoDevolucaoDocumento" id="motivoDevolucaoDocumento" class="motivo-textarea"></textarea>
  </div>
</ng-template>

<!-- Modal ALERTA -->
<ng-template #templateModalAlerta>
  <app-modal-simples [title]="'Ajustes documento'" (cancel)="fecharModalPendenciaDocumentos()">
    <div class="">
      <h2 class="text-danger text-bold-500 mb-2 text-center">ATENÇÃO, PENDÊNCIA NO(S) DOCUMENTO(S) !</h2>
      <h3 *ngIf="heColaborador" class="text-center mb-2">
        Todos os documentos precisam estar no status
        <span class="badge badge-danger round">"Correção"</span>
        ou
        <span class="badge badge-success round">"OK"</span>
        antes de prosseguir.
      </h3>

      <h3 *ngIf="!heColaborador" class="text-center mb-2">
        {{ mensagemListaRetornoDM }}
      </h3>
      <h3 class="mb-2">Detalhes dos Documentos Pendentes:</h3>
      <div class="table-responsive">
        <table class="table table-striped" role="grid">
          <thead class="bg-table-geia white text-center">
            <tr>
              <th class="text-center">Nome</th>
              <th class="text-center">Total de Documentos</th>
              <ng-container *ngIf="stepAtual != propostaEnum.ANALISE; else ehEnviado">
                <th class="text-center">Documentos Pendentes</th>
                <th class="text-center">Documentos para Correção</th>
              </ng-container>
              <ng-template #ehEnviado>
                <th class="text-center">Documentos com Status de Enviado</th>
              </ng-template>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detail of listaRetornoEnvio">
              <td class="text-center text-bold-400">{{ detail.name }}</td>
              <td class="text-center text-bold-400">
                {{ detail.totalDocuments }}
              </td>
              <ng-container *ngIf="stepAtual != propostaEnum.ANALISE; else ehEnviado">
                <td class="text-center text-bold-400">
                  {{ detail.pendingDocumentsCount }}
                </td>
                <td class="text-bold-400 text-center">
                  {{ detail.correctionDocumentsCount }}
                </td>
              </ng-container>
              <ng-template #ehEnviado>
                <td class="text-bold-400 text-center">
                  {{ detail.sentingDocumentsCount }}
                </td>
              </ng-template>
            </tr>
          </tbody>
        </table>
        <div>
          <div class="mb-3">
            <h3 class="mt-2"><strong>O que fazer?</strong></h3>
            <ul>
              <li>Certifique-se de que não há nenhuma pendência nos documentos da lista acima.</li>
            </ul>
          </div>

          <div class="mt-2 align-center">
            <button
              (click)="fecharModalPendenciaDocumentos()"
              class="btn-simule btn btn-outline-secondary btn-min-width box-shadow-4"
              style="max-height: 3rem">
              <i class="fa fa-check"></i>
              Corrigir
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal-simples>
</ng-template>

<ng-template #templateModalExistente>
  <app-modal-simples [title]="'Aviso - Documento'" (cancel)="fecharModal()">
    <div class="text-center-modal">
      <div class="d-flex align-items-center">
        <div class="caixa-texto-modal">
          <h1 class="text-center text-bold-600 mt-1 mb-2">Aviso!</h1>
          <p class="typing-text preto-geia mt-2 mb-2">
            Documentos ja foram encaminhados para Análise, aguarde o retorno.
          </p>
          <div class="text-center">
            <button
              (click)="irParaAnalise()"
              class="btn cursor-pointer btn-round btn-success-geia white min-width-btn box-shadow-4 mr-1 mb-1">
              <b>Verificar Status</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal-simples>
</ng-template>
<!-- Modal Aditivo (Portabilidade/Súmula 21) -->
<ng-template #modalAditivo>
  <div class="modal-content">
    <div class="modal-body">
      <app-documento-aditivo
        [nomeTitular]="nomeModalAditivo"
        [codigoProposta]="this.codigoProposta"
        [entidadeProposta]="entidadeProposta"
        [tipoProposta]="mostrarModalAditivo"
        [nomeEntidade]="nomeEntidade"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
        [razaoSocialEntidade]="razaoSocialEntidade"></app-documento-aditivo>
      <div class="row ml-1">
        <div class="mb-1 mt-2">
          <input [(ngModel)]="checkboxModalAditivo" id="checkboxSumula21" type="checkbox" />
          <label class="termo-aceite bold alinhamento-texto-check-box" for="checkboxSumula21">
            Li e concordo com o Termo de Aditivo
            {{ getDescricaoTipoProposta(mostrarModalAditivo) }}.
            <a class="ml-1"></a>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-end m-1">
    <button
      [disabled]="!checkboxModalAditivo"
      (click)="assinarTermoAditivo(idBeneficiarioDoModalAditivo)"
      class="btn-simule btn btn-outline-secondary btn-min-whidth">
      <i class="fa fa-check"></i>
      Assinar e Avançar
    </button>
  </div>
</ng-template>

<ng-template #modalConfirmacaoDocumentacaoEnviada let-modal>
  <app-modal-simples [title]="'Documentação Enviada'" (cancel)="fecharModalAviso()">
    <div class="caixa-texto-modal">
      <h1 class="text-center text-bold-600 mt-1 mb-2">Aviso!</h1>
      <h4 class="typing-text preto-geia mt-2 mb-2">{{ mensagemModal }}</h4>
      <div class="text-center">
        <button
          (click)="fecharModalAviso()"
          class="btn cursor-pointer btn-round btn-success-geia white min-width-btn box-shadow-4 mr-1 mb-1">
          <b>Ciente</b>
        </button>
      </div>
    </div>
  </app-modal-simples>
</ng-template>

<!-- Formulário Inscrição Entidade -->
<ng-template #modalFormularioInscricaoEntidade let-modal>
  <app-modal-simples (cancel)="fecharModalInscricao()">
    <div class="caixa-texto-modal">
      <app-formulario-inscricao-entidade-adservip
        *ngIf="this.nomeEntidade === 'ADSERVIP'"
        [formEntidadeSomenteLeitura]="true"
        [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
        [nomeEntidade]="nomeEntidade"></app-formulario-inscricao-entidade-adservip>
      <app-formulario-inscricao-entidade-abje
        *ngIf="this.nomeEntidade === 'ABJE'"
        [formEntidadeSomenteLeitura]="true"
        [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
        [logoEntidade]="logoEntidade"
        [nomeEntidade]="nomeEntidade"></app-formulario-inscricao-entidade-abje>
    </div>
    <div style="text-align: left">
      <app-assinatura-documento
        [nomeTitular]="nomeTitular"
        [dataAssinatura]="dataAssinaturaFormInscricao"
        [horaAssinatura]="horaAssinaturaFormInscricao"
        [ehDocFinal]="false"></app-assinatura-documento>
    </div>
    <div class="modal-footer">
      <button class="btn btn-simule btn btn-info btn-min-width" (click)="fecharModalInscricao()">Fechar</button>
    </div>
  </app-modal-simples>
</ng-template>
<ng-template #ModalConfirmacaoComponentRevisarDocumento let-modal>
  <app-modal-simples [title]="'Documentos Concluídos'" (cancel)="fecharModalRevisarOuAvancar()">
    <div class="caixa-texto-modal">
      <h5 class="typing-text preto-geia mt-2 mb-2">Todos os documentos foram enviados com sucesso!</h5>
      <h5 class="typing-text preto-geia mt-2 mb-2">Deseja revisar os documentos ou seguir para a próxima etapa?</h5>
    </div>

    <div class="modal-footer">
      <app-geia-button
        type="success"
        label="Revisar "
        icon="fa fa-check"
        (click)="RevisarDocumento()"
        extraClass="round"></app-geia-button>
      <app-geia-button
        type="warning"
        label="Seguir sem Revisar"
        icon="fa fa-arrow-right"
        (click)="beneficiarioAvancar(templateModalAlerta, templateModalExistente)"
        extraClass="round"></app-geia-button>
    </div>
  </app-modal-simples>
</ng-template>
